import React from "react";
import Grid from "@material-ui/core/Grid";
import { createStyles, Theme, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FormDialog from "../FormDialog";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import WarningIcon from "@material-ui/icons/Warning";
import { orange, red } from "@material-ui/core/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorBackground: {
      backgroundColor: (props: any) => props.color,
      color: theme.palette.getContrastText(red[500]),
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      padding: "0.5% 2%",
    },
    snackbar: {
      width: "40%",
    },
    acceptButton: {
      borderColor: (props: any) => props.color,
      color: (props: any) => props.color,
    },
  })
);

interface IProps {
  errors: string[] | null;
  isWarning?: boolean;
  onHide: Function;
}

const ModalAlert: React.FC<IProps> = ({
  errors = [],
  isWarning = false,
  onHide,
}: IProps) => {
  const classes = useStyles({ color: isWarning ? orange[600] : red[600] });

  return (
    <FormDialog
      title={isWarning ? "Uwaga!" : "Wystąpił wyjątek!"}
      hideActions
      open={Boolean(errors && errors.length > 0)}
      onClose={onHide}
      onAccept={onHide}
    >
      <WarningIcon
        fontSize={"large"}
        style={{
          display: "block",
          margin: "0 auto",
          fontSize: "15vh",
          color: isWarning ? orange[500] : red[500],
        }}
      />
      <Box my={4}>
        <Grid container>
          <Grid item xs={12}>
            {errors &&
              errors.map((item, index) => (
                <Paper key={index} className={classes.errorBackground}>
                  <Typography variant={"button"}>{item}</Typography>
                </Paper>
              ))}
          </Grid>
        </Grid>
      </Box>
      <Button
        className={classes.acceptButton}
        onClick={() => onHide()}
        variant={"outlined"}
        fullWidth
      >
        Akceptuj
      </Button>
    </FormDialog>
  );
};

export default ModalAlert;
